export default __webpack_public_path__ + "static/media/title-en.e06c4531.webp";